module.exports = __webpack_public_path__ + "07_mole.ccd99c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer3/07_mole.png
// module id = mQ/x
// module chunks = 0